export default "__VITE_ASSET__8180d685__"